import { OnInit, Input, Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-validation-message',
    templateUrl: 'validation-message.component.html',
    standalone: false
})

export class ValidationMessageComponent implements OnInit {

  @Input() form: UntypedFormGroup;
  @Input() path: string;
  @Input() name: string;
  @Input() label: string;

constructor() { }

ngOnInit() {
}

}
